import { Text, ReactTable, Box } from '@wegroup/design-system';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from 'react-table';
import { FormOption } from '../../../../../../../types/Form';
import { toEuro } from '../../../../../../sales-conversation/src/utils/stringUtils';
import { UnitObject } from '../../../../types/CompanyScanTypes';
import TableActionsMenu from '../common/TableActionsMenu';
import TableFiller from '../common/TableFiller';

interface Props {
  units: UnitObject[];
  options: FormOption[];
  onEdit: (unit: UnitObject, index: number) => void;
  onRemove: (index: number) => void;
}

const UnitsTable: React.FC<React.PropsWithChildren<Props>> = ({
  units,
  options,
  onEdit,
  onRemove,
}) => {
  const { t } = useTranslation();

  const renderAmountCell = (cell: Cell) => {
    const { value } = cell?.row?.original as UnitObject;

    return <Text color="text.gray">{toEuro(value)}</Text>;
  };

  const renderUnitCell = (cell: Cell) => {
    const { unit } = cell?.row?.original as UnitObject;

    return (
      <Text color="text.gray">
        {options.find(({ value }) => value === unit)?.label}
      </Text>
    );
  };

  const renderActionMenuCell = (cell: Cell) => {
    const unit = cell?.row?.original as UnitObject;
    const index = cell?.row?.index;

    return (
      <TableActionsMenu
        onEdit={() => onEdit(unit, index)}
        onRemove={() => onRemove(index)}
      />
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: t('WAGE_BILL'),
        accessor: 'value',
        Cell: renderAmountCell,
        isSticky: true,
      },
      {
        Header: t('CATEGORY'),
        accessor: 'unit',
        Cell: renderUnitCell,
      },
      {
        Header: t('ACTIONS'),
        id: 'actions',
        Cell: renderActionMenuCell,
        disableSortBy: true,
      },
    ],
    [units],
  );

  return (
    <Box>
      <ReactTable
        data={units}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        columns={columns as any}
      />
      {units.length === 0 && (
        <TableFiller>
          <Text>{t('FLOWS_COMPANY-SCAN_UNITS-INPUT_EMPTY-TABLE')}</Text>
        </TableFiller>
      )}
    </Box>
  );
};

export default UnitsTable;
